import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'decimalPlaces',
  standalone: true,              // ✅ standalone so you can import it in components
})
export class DecimalPlacesPipe implements PipeTransform {
  obsIdsToIgnoreTrimming: number[] = [54260, 54261];

  constructor(private decimalPipe: DecimalPipe) {} // ✅ inject Angular's DecimalPipe, not itself

  transform(
    val: any,
    decimalPlace: number = 1,
    JBTStandardObservationId?: number
  ): unknown {
    const format = '1.0-' + decimalPlace;

    if (
      JBTStandardObservationId &&
      this.obsIdsToIgnoreTrimming.includes(JBTStandardObservationId)
    ) {
      return val;
    } else if (
      val != null &&
      !isNaN(val) &&
      val.toString().indexOf('.') !== -1
    ) {
      const transformed = this.decimalPipe.transform(val, format);
      return !isNaN(Number(transformed)) ? +transformed! : transformed;
    }

    return val;
  }
}
